import { render } from "./IndexView.vue?vue&type=template&id=35ddef10&scoped=true"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"

import "./IndexView.vue?vue&type=style&index=0&id=35ddef10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ddef10"]])

export default __exports__